export var IdLang;
(function (IdLang) {
    IdLang["None"] = "none";
    IdLang["BrazilianPortuguese"] = "pt-BR";
    IdLang["Bulgarian"] = "bg";
    IdLang["Czech"] = "cs";
    IdLang["Danish"] = "da";
    IdLang["Dutch"] = "nl";
    IdLang["English"] = "en";
    IdLang["Finnish"] = "fi";
    IdLang["French"] = "fr";
    IdLang["German"] = "de";
    IdLang["Greek"] = "el";
    IdLang["Hungarian"] = "hu";
    IdLang["Italian"] = "it";
    IdLang["Japanese"] = "ja";
    IdLang["Lithuanian"] = "lt";
    IdLang["Norwegian"] = "no";
    IdLang["Polish"] = "pl";
    IdLang["Romanian"] = "ro";
    IdLang["Russian"] = "ru";
    IdLang["Slovak"] = "sk";
    IdLang["Spanish"] = "es";
    IdLang["Swedish"] = "sv";
    IdLang["Turkish"] = "tr";
})(IdLang || (IdLang = {}));



//////////////////
// WEBPACK FOOTER
// ./src/utils/i18n/IdLang.ts
// module id = 202
// module chunks = 3